import custom from '../config/custom'
import store from '../store'
import { UNAUTHORIZE } from '../modules/auth'

const __DEV__ = process.env.NODE_ENV !== 'production'
const socketIOClient = require('socket.io-client')
const sailsIOClient = require('sails.io.js')
const io = sailsIOClient(socketIOClient)

io.sails.url = custom.baseUrl
io.sails.path = __DEV__ ? '' : '/socket.io'
io.sails.reconnection = true

export const on = (evName, fn) => {
  io.socket.on(evName, fn)
}

export const off = (evName, fn) => {
  io.socket.off(evName, fn)
}

export const request = (url, options) => {
  return new Promise((resolve, reject) => {
    io.socket.request(
      {
        ...options,
        url: `${url}`
      },
      (response, jwres) => {
        if (jwres.statusCode === 401) {
          store.dispatch({ type: UNAUTHORIZE });
        }
        
        if (jwres.error) {
          reject(response);
        }
        resolve(response);
      }
    );
  })
}

export const get = (url) => {
  return request(`${url}`)
}

export const reconnect = () => {
  io.socket.disconnect()
  io.socket.reconnect()
}



// WEBPACK FOOTER //
// ./src/utils/sockets.js